<div class="payments-legal">
  <a class="payments-legal-back" routerLink="/pagamenti">← Torna ai pagamenti</a>

  <header class="payments-legal-head">
    <h1>Informativa privacy — Pagamenti online</h1>
    <p class="payments-legal-updated">Ultimo aggiornamento: ottobre 2026</p>
  </header>

  <section class="payments-legal-panel">
    <h2>1. Titolare del trattamento</h2>
    <p>
      Il titolare del trattamento è la
      <strong>Confraternita di Misericordia di Borgo San Lorenzo</strong>,
      Via Giotto, 34 — 50032 Borgo San Lorenzo (FI), P. IVA 01343220487.
    </p>
    <p>
      Contatti:
      <a href="mailto:home@misericordia.net">home&#64;misericordia.net</a>,
      PEC
      <a href="mailto:misericordiabsl@legalmail.it">misericordiabsl&#64;legalmail.it</a>,
      tel. <a href="tel:0558494118">055 8494118</a>.
    </p>
  </section>

  <section class="payments-legal-panel">
    <h2>2. Ambito</h2>
    <p>
      Questa informativa riguarda esclusivamente la sezione pagamenti online
      del sito (quota associativa annuale, canone lampade votive cimiteriali e
      donazione libera). Per la navigazione del sito e dell’archivio si applica
      l’<a routerLink="/privacy">informativa generale</a>.
    </p>
  </section>

  <section class="payments-legal-panel">
    <h2>3. Dati raccolti</h2>
    <p>
      In fase di compilazione del modulo di pagamento possono essere richiesti,
      a seconda del servizio scelto:
    </p>
    <ul>
      <li>nome e cognome;</li>
      <li>codice fiscale;</li>
      <li>importo da versare;</li>
      <li>numero di lampade (per il servizio lampade votive);</li>
      <li>note eventuali fornite volontariamente dall’utente.</li>
    </ul>
    <p>
      I dati relativi allo strumento di pagamento (ad esempio carta) sono
      raccolti e trattati dal gestore dei pagamenti elettronici indicato al
      punto 5; la Misericordia non conserva i dati completi della carta.
    </p>
  </section>

  <section class="payments-legal-panel">
    <h2>4. Finalità e basi giuridiche</h2>
    <p>I dati sono trattati per:</p>
    <ul>
      <li>
        consentire l’esecuzione del pagamento richiesto (quota, lampade o
        donazione) e la corretta attribuzione dell’operazione
        (esecuzione di misure precontrattuali / del rapporto richiesto
        dall’interessato; per le donazioni, anche legittimo interesse e
        adempimenti connessi);
      </li>
      <li>
        adempiere a obblighi contabili, fiscali e di legge;
      </li>
      <li>
        prevenire frodi e garantire la sicurezza delle operazioni
        (interesse legittimo del Titolare).
      </li>
    </ul>
    <p>
      I dati non sono utilizzati per finalità di marketing o profilazione.
    </p>
  </section>

  <section class="payments-legal-panel">
    <h2>5. Gestore del pagamento (Numia)</h2>
    <p>
      L’esecuzione del pagamento online avviene tramite il sistema di
      pagamento <strong>Numia</strong>, che opera come fornitore di servizi di
      pagamento. I dati necessari all’operazione sono comunicati a Numia per
      consentire l’autorizzazione e il regolamento del pagamento, secondo le
      modalità e le informative rese disponibili da tale fornitore.
    </p>
    <p>
      Eventuali costi di servizio applicati dal sistema di pagamento sono
      mostrati in modo trasparente nel riepilogo prima della conferma.
    </p>
  </section>

  <section class="payments-legal-panel">
    <h2>6. Conservazione e sicurezza</h2>
    <p>
      I dati dell’operazione sono conservati per il tempo necessario alla
      gestione del pagamento e agli obblighi di legge (ad esempio
      civilistici e fiscali). Sono adottate misure organizzative e tecniche
      adeguate a proteggere i dati; per motivi di sicurezza non sono
      pubblicati dettagli sull’infrastruttura o sulle misure specifiche.
    </p>
  </section>

  <section class="payments-legal-panel">
    <h2>7. Destinatari</h2>
    <p>
      Oltre al personale autorizzato della Misericordia, i dati possono essere
      comunicati a Numia (per l’esecuzione del pagamento) e, ove necessario,
      a consulenti o autorità nei limiti di legge. Non sono oggetto di
      diffusione.
    </p>
  </section>

  <section class="payments-legal-panel">
    <h2>8. Cookie</h2>
    <p>
      Per cookie e memorizzazioni locali della sezione pagamenti si rinvia alla
      <a routerLink="/pagamenti/cookie">Cookie Policy della sezione pagamenti</a>.
    </p>
  </section>

  <section class="payments-legal-panel">
    <h2>9. Diritti dell’interessato</h2>
    <p>
      L’interessato può esercitare i diritti previsti dal GDPR (accesso,
      rettifica, cancellazione, limitazione, opposizione, portabilità ove
      applicabile) rivolgendosi ai recapiti del Titolare. È inoltre possibile
      proporre reclamo al Garante per la protezione dei dati personali
      (<a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer">www.garanteprivacy.it</a>).
    </p>
  </section>

  <section class="payments-legal-panel">
    <h2>10. Aggiornamenti</h2>
    <p>
      Questa informativa può essere aggiornata; la versione corrente è
      pubblicata su questa pagina con la data di revisione.
    </p>
  </section>
</div>
